<template>
    <div style="display: flex" :style="parseInt(active) === 1 ? '' : 'opacity: .5'">
        <v-switch style="flex-grow: 0;" v-model="active"
                  hide-details
                  color="blue"
                  :false-value="String(0)"
                  :true-value="String(1)"
                  @change="changeActive"
        />


        <span @click="$bus.$emit('pricelist:edit-protocol', [protocol, index, 'title'])" style="font-size: 13px; border-bottom: 2px solid #999; display: inline-block; flex-grow: 1; padding-top: 24px;"> {{ protocol.variation_titles[index][$store.state.language] }}</span>

        <span @click="$bus.$emit('pricelist:edit-protocol', [protocol, index, 'price'])" style="text-align: right; width: 90px; max-width: 90px; margin-left: 12px; font-size: 14px; border-bottom: 2px solid #999; display: inline-block; flex-grow: 0; padding-top: 24px;"> {{ formattedUnitPrice }}</span>

        <!-- <v-text-field
            v-model="protocol.variation_titles[index][$store.state.language]"
            class="text-field--f13"
            :style="parseInt(active) === 1 ? '' : 'opacity: .5'"
            maxlength="42"
            hide-details
            :placeholder="['preci_vertix', 'full_bridge'].includes(protocol.title) ? $t('settings.type_bridge') : $t('settings.type_treatment')"
            @focus="onFocus"
            @blur="$emit('blurred', $event)"
            @keypress="onEnterPress"
        /> -->
        <!-- <v-text-field
            v-model="formattedUnitPrice"
            maxlength="12"
            class="text-field--f13 settings-input--unit-price"
            :style="parseInt(active) === 1 ? '' : 'opacity: .5'"
            hide-details
            style="text-align: right; width: 90px; max-width: 90px; margin-left: 12px; flex-grow: 0;"
            :placeholder="$t('settings.treatment_unit_price')"
            @focus="onFocusPrice"
            @blur="onBlur"
            @keypress="onKeypress"
        >
        </v-text-field> -->


        <!-- <pm-price-input @click="onPriceClick" :style="parseInt(active) === 1 ? '' : 'opacity: .5'" v-model="protocol.variation_prices[index][$store.state.currency]" /> -->
    </div>
</template>

<style>
    .settings-input--unit-price input {
        text-align: right;
    }
    .v-text-field.text-field--f13 input {
        font-size: 13px!important;
        letter-spacing: -0.5px;
    }
</style>

<script>
import { scrollElementToTop } from "../../utils/user-interface";
export default {
    props: {
        item: {
            type: Object,
            default: function() {
                return ({
                    status: "1",
                    title: {},
                    price: {},
                });
            },
        },
        protocol: {
            type: Object,
        },
        index: {
            type: Number,
        },
    },
    data: () => {
        return ({
            switch1: true,
            unitPrice: "100",
            active: "0",
        });
    },
    created() {
        if (typeof this.protocol.variation_titles === "undefined") {
            this.$set(this.protocol, "variation_titles", [{}, {}, {}]);
        }

        if (typeof this.protocol.variation_titles[this.index] === "undefined") {
            this.$set(this.protocol.variation_titles, this.index, {});
        }

        if (typeof this.protocol.variation_titles[this.index][this.$store.state.language] === "undefined") {
            this.$set(this.protocol.variation_titles[this.index], this.$store.state.language, "");
        }

        if (typeof this.protocol.variation_active === "undefined") {
            this.$set(this.protocol, "variation_active", ["1", "1", "1"]);
        }

        if (typeof this.protocol.variation_prices === "undefined") {
            this.$set(this.protocol, "variation_prices", [{}, {}, {}]);
        }

        if (typeof this.protocol.variation_prices[this.index] === "undefined") {
            this.$set(this.protocol.variation_prices, this.index, {});
        }

        if (typeof this.protocol.variation_prices[this.index][this.$store.state.currency] === "undefined") {
            this.$set(this.protocol.variation_prices[this.index], this.$store.state.currency, "0");
        }

        if (typeof this.protocol.variation_active[this.index] === "undefined") {
            this.$set(this.protocol.variation_active, this.index, "0");
        }

        this.active = this.protocol.variation_active[this.index];
    },
    computed: {
        formattedUnitPrice: {
            get() {
                let price = this.protocol.variation_prices[this.index][this.$store.state.currency];

                if (typeof price === "undefined" || price === 0) {
                    return 0;
                }

                price = this.addThousandSeparator(price.toString().replace(",", "."));

                return price;
            },
            set(val) {
                const price = val.toString().replace(/([^0-9]+)/g, "");

                this.$set(this.protocol.variation_prices[this.index], this.$store.state.currency, price);
            },
        },
    },
    methods: {
        onPriceClick() {
            if (parseInt(this.active) === 0) {
                this.active = '1';
                this.changeActive();
            }
        },
        addThousandSeparator(n) {
            const nStr = n.toString();
            const remainder = nStr.length % 3;

            let formatted = (nStr.substr(0, remainder) + nStr.substr(remainder).replace(/(\d{3})/g, ' ' + "$1")).trim();

            if (formatted[0] === ' ') {
                formatted = formatted.substr(1);
            }

            return formatted;
        },
        selectText(event) {
            const $input = event.target;

            $input.focus();
            $input.selectionStart = $input.selectionEnd = $input.value.length;
        },
        formatPrice(price) {
            const locale = this.$store.state["language"] || navigator.language;
            const intl = new Intl.NumberFormat(locale);
            const formatted = intl.format(price);

            return formatted === "NaN" ? 0 : formatted;
        },
        changeActive() {
            this.$set(this.protocol.variation_active, this.index, this.active);
            this.$nextTick(()=>{
               this.$emit("toggle");
            });
        },
        onBlur() {
            this.$emit("blurred");

            document.querySelector("#main-scrollable-content .scroll-helper").style.height = 0;
        },
        onFocusPrice(event) {
            event.target.select(); // uncomment if approved
            this.onFocus(event);
        },
        onFocus(event) {
            this.$emit("focused");

            /*if (parseInt(this.active) === 0) {
                this.active = '1';
                this.changeActive();
            }*/

            scrollElementToTop(event.target, 0);

            /*const {abs} = Math;
            const {clientHeight} = document.documentElement;
            const {top} = event.target.getBoundingClientRect();
            const shouldScrollUp = abs(1 - (clientHeight - top) / clientHeight);

            if (shouldScrollUp <= 0.6) {
                return;
            }

            const $content = document.querySelector("#main-scrollable-content");
            const $scrollHelper = $content.querySelector(".scroll-helper");

            if ($content.scrollTop / $content.scrollHeight > 0.7) {
                $scrollHelper.style.height = "40vh";
            }

            $content.scrollTo({top: $content.scrollTop + parseInt(clientHeight / 3), behavior: "smooth"});*/
        },
        onEnterPress(event) {
            if (event.code === "Enter" || event.key === "Enter" || event.keyCode === 13) {
                return event.target.blur();
            }
        },
        onKeypress(event) {
            const charCode = event.which || event.keyCode;

            if (event.code === "Enter" || event.key === "Enter" || event.keyCode === 13) {
                return event.target.blur();
            }

            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                event.preventDefault();
            }
        },
    },
};
</script>
